import { ApiP4MetricsResponse, P4Metrics } from "@/core/dashboard/entities/P4Metrics";
import { toColorIndicator } from "./colorIndicatorMapper";

/**
 * Maps GET /api/v1/dashboard/conformite/p4/metrics to the P4Metrics domain model.
 */
export default class P4MetricsMapper {
  static toDomain(api: ApiP4MetricsResponse): P4Metrics {
    return {
      highRiskCoverage: {
        uncoveredCount: api.highRiskCoverage?.uncoveredCount ?? 0,
        totalHighRiskCount: api.highRiskCoverage?.totalHighRiskCount ?? 0,
        coverageRate: api.highRiskCoverage?.coverageRate ?? null,
        colorIndicator: toColorIndicator(api.highRiskCoverage?.colorIndicator),
      },
      sodConformity: {
        totalPublishedRoles: api.sodConformity?.totalPublishedRoles ?? 0,
        compliantRoles: api.sodConformity?.compliantRoles ?? 0,
        warnRoles: api.sodConformity?.warnRoles ?? 0,
        blockRoles: api.sodConformity?.blockRoles ?? 0,
        conformityRate: api.sodConformity?.conformityRate ?? null,
        derogationsVolume: api.sodConformity?.derogationsVolume ?? null,
        colorIndicator: toColorIndicator(api.sodConformity?.colorIndicator),
      },
      eddWorkflowAvailable: api.eddWorkflowAvailable ?? false,
      avgEddL2ValidationHours: api.avgEddL2ValidationHours ?? null,
      activeEddCasesCount: api.activeEddCasesCount ?? null,
    };
  }
}
